import { markStall } from './stall-mark';

type Ft3dEventDelayDiagnostic = {
  active?: boolean;
  mark?: (boundary: string, detail?: unknown) => void;
};

/**
 * Dormant browser-timeline hook used by the staging-only FT3D startup probe.
 * The hook is installed before navigation; ordinary clients pay only this guarded lookup.
 */
export function markFt3dEventDelayDiagnostic(boundary: string, detail?: unknown): void {
  if (boundary === 'iframe.scene-phase') markStall('scene:' + String((detail as { name?: string } | undefined)?.name ?? 'render').slice(0, 58));
  const diagnostic = (window as Window & {
    __ft3dEventDelayDiagnostic?: Ft3dEventDelayDiagnostic;
  }).__ft3dEventDelayDiagnostic;
  if (diagnostic?.active !== true) return;
  try {
    diagnostic.mark?.(boundary, detail);
  } catch {
    // Diagnostics must never alter movement delivery.
  }
}
